import { defineNuxtPlugin } from '#app/nuxt'
import { LazyKenticoComponentsAccordion, LazyKenticoComponentsAccordionTab, LazyKenticoComponentsBetwayJackpots, LazyKenticoComponentsCardScroller, LazyKenticoComponentsCasinoJackpots, LazyKenticoComponentsContact, LazyKenticoComponentsCustomContent, LazyKenticoComponentsExpandingContent, LazyKenticoComponentsHowTos, LazyKenticoComponentsJackpotsFooterModal, LazyKenticoComponentsKenticoClientContent, LazyKenticoComponentsKenticoHeader, LazyKenticoComponentsPromotionalToast, LazyKenticoComponentsScrollingSponsors, LazyKenticoComponentsWhyBetway } from '#components'
const lazyGlobalComponents = [
  ["KenticoComponentsAccordion", LazyKenticoComponentsAccordion],
["KenticoComponentsAccordionTab", LazyKenticoComponentsAccordionTab],
["KenticoComponentsBetwayJackpots", LazyKenticoComponentsBetwayJackpots],
["KenticoComponentsCardScroller", LazyKenticoComponentsCardScroller],
["KenticoComponentsCasinoJackpots", LazyKenticoComponentsCasinoJackpots],
["KenticoComponentsContact", LazyKenticoComponentsContact],
["KenticoComponentsCustomContent", LazyKenticoComponentsCustomContent],
["KenticoComponentsExpandingContent", LazyKenticoComponentsExpandingContent],
["KenticoComponentsHowTos", LazyKenticoComponentsHowTos],
["KenticoComponentsJackpotsFooterModal", LazyKenticoComponentsJackpotsFooterModal],
["KenticoComponentsKenticoClientContent", LazyKenticoComponentsKenticoClientContent],
["KenticoComponentsKenticoHeader", LazyKenticoComponentsKenticoHeader],
["KenticoComponentsPromotionalToast", LazyKenticoComponentsPromotionalToast],
["KenticoComponentsScrollingSponsors", LazyKenticoComponentsScrollingSponsors],
["KenticoComponentsWhyBetway", LazyKenticoComponentsWhyBetway]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
